/**
 *
 * @module tokenClientEndpoint
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef TokenClientEndpoint
 * @type {Object}
 *
 * @property {String} exchange
 *
 */

/**
 *
 * @enum
 * @type {TokenClientEndpoint}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    exchange: null
});



// WEBPACK FOOTER //
// ./src/services/token/tokenClientEndpoint.js